import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgExit = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.2 1.06665C2.61089 1.06665 2.13333 1.54422 2.13333 2.13332V13.8667C2.13333 14.4558 2.6109 14.9333 3.2 14.9333H11.2C11.4945 14.9333 11.7333 14.6945 11.7333 14.4C11.7333 14.1055 11.4945 13.8667 11.2 13.8667H3.2V2.13332H11.2C11.4945 2.13332 11.7333 1.89453 11.7333 1.59998C11.7333 1.30543 11.4945 1.06665 11.2 1.06665H3.2ZM13.4438 5.22286C13.2355 5.01458 12.8978 5.01458 12.6895 5.22286C12.4813 5.43114 12.4813 5.76883 12.6895 5.9771L14.1791 7.46665H6.93333C6.63878 7.46665 6.4 7.70543 6.4 7.99998C6.4 8.29453 6.63878 8.53332 6.93333 8.53332H14.1791L12.6895 10.0229C12.4813 10.2311 12.4813 10.5688 12.6895 10.7772C12.8978 10.9854 13.2355 10.9854 13.4438 10.7772L15.8438 8.3771C16.0521 8.16883 16.0521 7.83114 15.8438 7.62286L13.4438 5.22286Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgExit)
const IconSvgExit = createIcon(ForwardRef, 'SvgExit')
export default IconSvgExit
